module.exports = __webpack_public_path__ + "assets/pattern-0f4d2e3a537e38a65e2d9811a7fdee01.svg";